/**
 * Portal-wide rate constants. The mileage rate Proxemics uses for
 * timesheet reimbursement lives here so there's one spot to update
 * when the rate changes.
 *
 * This is an INTERNAL Proxemics rate that Jillian sets — it is NOT
 * tied to the IRS standard mileage rate. Change the number on the
 * line below and the rest of the portal picks it up.
 *
 * Approved timesheets stamp the rate they used at the time of approval
 * (MileageRateUsed column on the Timesheets SharePoint list), so changing
 * this constant does NOT retroactively alter already-approved timesheets.
 */

// Proxemics mileage rate (dollars per mile). Change this number to
// update the rate going forward — saved timesheets keep their stamped
// rate so historical billing stays consistent.
export const MILEAGE_RATE_USD_PER_MILE = 0.45;
export const MILEAGE_RATE_EFFECTIVE_YEAR = 2026;

// Historical rates kept for reference / audit. Extend the bottom of the
// list rather than editing existing entries.
export const MILEAGE_RATE_HISTORY = [
  { year: 2024, rate: 0.67 },
  { year: 2025, rate: 0.70 },
  { year: 2026, rate: 0.45 },
];

// Backward-compatible aliases for any older imports still using the
// IRS_-prefixed names. New code should import the renamed constants
// directly; these can be removed once the imports are swept.
export const IRS_MILEAGE_RATE_USD_PER_MILE = MILEAGE_RATE_USD_PER_MILE;
export const IRS_MILEAGE_RATE_EFFECTIVE_YEAR = MILEAGE_RATE_EFFECTIVE_YEAR;
export const IRS_MILEAGE_RATE_HISTORY = MILEAGE_RATE_HISTORY;

/**
 * Dollar value of a mileage entry at the current rate. Kept as a named
 * helper (vs. `miles * MILEAGE_RATE_USD_PER_MILE` inline everywhere)
 * so we can swap in a date-aware lookup later without hunting down
 * callers.
 */
export function calcMileageDollars(miles) {
  const n = Number(miles);
  if (!Number.isFinite(n) || n <= 0) return 0;
  return Math.round(n * MILEAGE_RATE_USD_PER_MILE * 100) / 100;
}
